<template>
  <div class="h-full relative overflow-auto flex flex-col overflow-x-hidden">
    <slot></slot>
    <Footer/>
  </div>
</template>
